import React from "react";
import { Pagination } from "antd";

const Paginate = props =>
  props.nbItems && props.nbItems > 0 ? (
    <Pagination
      current={props.page}
      pageSize={props.pageSize}
      total={props.pages * props.pageSize}
      onChange={page => {
        props.getNext(page);
      }}
    />
  ) : null;

export default Paginate;



// WEBPACK FOOTER //
// src/components/pagination/Pagination.js